/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { getLoginUser } from './loginService';

const base_url = `${process.env.BACKEND_API_BASE_URL}/flight.php`;

export const airFlightService = {
  get_airlines: async ({ search, limit, token }) => axios.get(base_url, {
    params: {
      method: 'get_airlines',
      search,
      limit,
      token: token || getLoginUser().token,
    },
  }),
  get_flights: async (data) =>axios.get(base_url, {
    params: {
      method: 'get_flights',
      ...data,
      token: data?.token || getLoginUser().token,
    },
  }),
};
